import React from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import ViewForm from '../../Admin/Form/ViewForm';
import ShareUserFormData from '../PublicUserFormData/ShareUserFormData';

function UserFormModal({ roomId, chatFormId, setChatFormId, canDownload, room }) {
    const [formInfo, setFormInfo] = useState({});
    const history = useHistory();
    const handleClose = useCallback(() => {
        setChatFormId(null);
        history.push(`/teams/${roomId}`);
    }, [history, roomId, setChatFormId]);
    return (
        <Modal show={Boolean(chatFormId)} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="d-flex flex-row justify-content-between">
                        <div className="d-flex flex-row align-items-center">
                            <span>{formInfo?.name} Form</span>
                            <span className="badge badge-info ml-4">{(formInfo || {})?.type}</span>
                            <span className="badge badge-warning">
                                {((formInfo || {})?.specialityForm || {})?.type}
                            </span>
                        </div>
                        <ShareUserFormData form={formInfo} roomId={roomId} userformdataId={chatFormId} />
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ViewForm
                    room={room}
                    formId={chatFormId}
                    hide={handleClose}
                    showSignature={true}
                    setFormInfo={setFormInfo}
                    canDownload={canDownload}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UserFormModal;
